// Include ChartJS JS library.
require('chart.js/dist/Chart')